'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'brush';
var width = 384;
var height = 512;
var aliases = [];
var unicode = 'f55d';
var svgPathData = ['M48 48l0 240 288 0 0-240L224 48l0 64 0 16-32 0 0-16 0-64-64 0 0 96 0 16-32 0 0-16 0-96L48 48z', 'M48 288L48 48l48 0 0 96 0 16 32 0 0-16 0-96 64 0 0 64 0 16 32 0 0-16 0-64 112 0 0 240L48 288zM0 384l48 0 80 0 0 128 128 0 0-128 80 0 48 0 0-48 0-288 0-48L336 0 48 0 0 0 0 48 0 336l0 48zm192 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBrush = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;